import _ from 'lodash';

import { core } from '@tock/coretypes';

interface PurchaseDetailsWithDispute {
  dispute?: core.PaymentDispute | core.IPaymentDispute | null;
}

export function isDisputed(purchaseDetails: PurchaseDetailsWithDispute): boolean {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return !!purchaseDetails.dispute && _.lowerCase(purchaseDetails.dispute.status!) !== 'won';
}
